module.exports = __webpack_public_path__ + "static/img/Krung_Thai_Bank_logo.svg.799e7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Krung_Thai_Bank_logo.svg.png
// module id = I9Ik
// module chunks = 3